<template>
    <div class="w-100 my-5 d-flex justify-content-center">
        <hollow-dots-spinner
            :animation-duration="1000"
            :color="'#4F842C'"
            :dot-size="15"
            :dots-num="3"
        />
    </div>
</template>

<script>
import {HollowDotsSpinner} from 'epic-spinners';

export default {
    name: 'Loader',
    components: {
        HollowDotsSpinner,
    },
};
</script>

<style scoped>

</style>
